import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { getCheckIdList } from '../../../../helpers/common/CheckBoxValues';
import { propArrayShape, propFunc, propId, propNumber, propShape, propStr, propValidate, } from '../../../../helpers/custom-prop-types';
import { getFormValue } from '../../../../helpers/form';
import { validateOther10SmallRequired } from '../../../../validate/common';
import { Checkbox } from '../../FormFields';
import InputErrorWithConnect from '../InputErrorWithConnect';
import PlainInputField from './PlainInputField';
class InlineMultipleCheckBoxListFieldsAndLabel extends Component {
    constructor(props) {
        super(props);
        this.getState = (props) => {
            const { maxCount, name, otherId, thisForm } = props;
            const mainFormValues = getFormValue(thisForm, name) || {};
            const idList = getCheckIdList(mainFormValues);
            let currentValues = [];
            if (maxCount > 0) {
                currentValues = idList;
            }
            return {
                currentValues,
                isOtherCheck: idList.includes(otherId),
            };
        };
        this.state = this.getState(props);
    }
    shouldComponentUpdate(nextProps) {
        const { maxCount, name, otherId, thisForm } = this.props;
        const formValues = getFormValue(thisForm, name);
        const nextFormValues = getFormValue(nextProps.thisForm, nextProps.name);
        if (maxCount !== nextProps.maxCount ||
            name !== nextProps.name ||
            otherId !== nextProps.otherId ||
            formValues !== nextFormValues) {
            this.setState(this.getState(nextProps));
        }
        return true;
    }
    render() {
        const { annotationClass, annotationText, label, lists, maxCount, name, noMessage, otherName, otherPlaceHolder, otherValidate, wrapOnChange, } = this.props;
        const { currentValues, isOtherCheck } = this.state;
        const maxText = maxCount > 0 ? `最大${maxCount}つまで選択可能` : '';
        const setAnnotation = annotationText || maxText;
        return (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsxs("h3", { children: [label, setAnnotation && (_jsx("small", Object.assign({ className: annotationClass }, { children: setAnnotation })))] }), lists.length === 0 ? (_jsx("small", { children: noMessage })) : (_jsxs(_Fragment, { children: [_jsx("ul", Object.assign({ className: 'inline-multiple-checkbox' }, { children: lists.map((listValue) => {
                                const isDisabled = maxCount > 0 &&
                                    currentValues.length >= maxCount &&
                                    !currentValues.includes(listValue.id);
                                return (_jsx("li", Object.assign({ className: `mr05 mb1 ${isDisabled ? 'is-disabled' : ''}` }, { children: _jsx(Checkbox, { disabled: isDisabled, labelName: 'name', name: `${name}[${listValue.id}]`, option: listValue, valueName: 'id', wrapOnChange: wrapOnChange }) }), listValue.id));
                            }) })), otherName && (_jsxs("div", { children: [_jsx(PlainInputField, { className: 'input-form-text asign-state', disabled: !isOtherCheck, name: otherName, placeholder: otherPlaceHolder, showError: false, validate: isOtherCheck ? otherValidate : [] }), _jsx(InputErrorWithConnect, { className: 'mt05', name: otherName })] }))] }))] })));
    }
}
InlineMultipleCheckBoxListFieldsAndLabel.propTypes = {
    annotationClass: propStr(),
    annotationText: propStr(),
    label: propStr().isRequired,
    lists: propArrayShape().isRequired,
    maxCount: propNumber(),
    name: propStr().isRequired,
    noMessage: propStr(),
    otherId: propId(),
    otherName: propStr(),
    otherPlaceHolder: propStr(),
    otherValidate: propValidate(),
    thisForm: propShape().isRequired,
    wrapOnChange: propFunc(),
};
InlineMultipleCheckBoxListFieldsAndLabel.defaultProps = {
    annotationClass: '',
    annotationText: '',
    maxCount: 0,
    noMessage: '選択肢がありません',
    otherId: undefined,
    otherName: '',
    otherPlaceHolder: 'その他',
    otherValidate: validateOther10SmallRequired,
    wrapOnChange: undefined,
};
export default InlineMultipleCheckBoxListFieldsAndLabel;
